const getDefaultWhenNull = (value, path, defaultValue) => { var _a; return (_a = value === null || value === void 0 ? void 0 : value[path]) !== null && _a !== void 0 ? _a : defaultValue; };
export default getDefaultWhenNull;
//# sourceMappingURL=get-default-when-null.js.map